import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { CardTitleInput } from '@trackback/widgets';
import { AsyncPipe } from '@angular/common';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { MatCardTitle } from '@angular/material/card';
import { WidgetInputBaseComponent } from '@app/widgets/widget-input-base.component';

@Component({
  selector: 'tb-card-title',
  imports: [DynamicWidgetDirective, AsyncPipe, ParsePipe, MatCardTitle],
  template: `
    <mat-card-title [class]="input().styleClasses | parse: context() | async">
      @for (child of input().children; track $index) {
        <ng-container [dynamicWidget]="child" [context]="context()" />
      }
    </mat-card-title>
  `,
  styles: `
    tb-card-title {
      display: contents;
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class CardTitleComponent extends WidgetInputBaseComponent<CardTitleInput> {}
